// React things
import React, { useState } from "react";

// Stylyes
import style from "./LoadingWrapper.module.css";

// Components
import ComponentWrapper from "./ComponentWrapper.jsx";
import Loading from "../Components/Loading/Loading.jsx";

export default function LoadingWrapper(props) {
  const [loading, setLoading] = useState(true);

  return (
    <div className={style["container"]}>
      <div className={loading ? style["show"] : style["hide"]}>
        <Loading />
      </div>
      <div className={loading ? style["hide"] : style["show"]}>
        <ComponentWrapper setLoading={setLoading}>
          {props.children}
        </ComponentWrapper>
      </div>
    </div>
  );
}
